import { Sizes, States, Variant, StatusVariant } from "../enum-types";

interface AtlChipProps {
    label?: string;
    variant?: Variant;
    reverseOrder?: boolean;
    size?: Sizes;
    state?: States;

    avatarIconName?: string;
    avatarClassName?: string;

    avatarPicturUrl?: string;
    avatarPictureAltText?: string;

    hiddenLabel?: string;

    iconName?: string;
    iconClassName?: string;

    clickable?: boolean;

    deletable?: boolean;
}

interface AtlStatusChipProps {
    label?: string;
    variant: StatusVariant;
    reverseOrder?: boolean;
    size?: Sizes;
    state?: States;
    avatarIconName?: string;
    showAvatarIcon?: boolean;
    hiddenLabel?: string;
    iconName?: string;
    iconClassName?: string;
    deletable?: boolean;
    clickable?: boolean;
}

export type { AtlChipProps, AtlStatusChipProps };
export { Sizes, Variant, States, StatusVariant };